'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _workingHours = require('../actions/workingHours');

var _enum = require('../enum');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  list: [],
  getWorkingHoursLoadState: _enum.status.SHOULD_CALL_API,
  loadState: _workingHours.WORKING_HOURS.LOAD,
  saveWorkingHoursLoadState: _enum.status.SHOULD_CALL_API,
  rooms: [],
  roomScheduleType: [],
  setBranchWorkingHoursResponse: undefined,
  setBranchWorkingHoursLoadState: _enum.status.SHOULD_CALL_API,
  branchWorkingHours: undefined,
  getBranchWorkingHoursLoadState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _workingHours.WORKING_HOURS.LOAD:
      return _extends({}, state, { loadState: _workingHours.WORKING_HOURS.LOAD, getWorkingHoursLoadState: _enum.status.FETCHING });
    case _workingHours.WORKING_HOURS.LOAD_DONE:
      {
        var roomsObj = {};
        if (payload.rooms && payload.rooms.data) {
          roomsObj = payload.rooms.data;
        }
        return _extends({}, state, roomsObj, {
          loadState: _workingHours.WORKING_HOURS.LOAD_DONE,
          getWorkingHoursLoadState: _enum.status.SUCCESS
        });
      }
    case _workingHours.WORKING_HOURS.LOAD_SUCCESS:
      return _extends({}, state, { list: payload.rooms, loadState: _workingHours.WORKING_HOURS.LOAD_SUCCESS });

    case _workingHours.WORKING_HOURS.LOAD_FAIL:
      return _extends({}, state, { getWorkingHoursLoadState: _enum.status.SUCCESS });

    case _workingHours.WORKING_HOURS.WORKING_HOURS.SUBMIT:
      return _extends({}, state, { saveWorkingHoursLoadState: _enum.status.SUBMITING });
    case _workingHours.WORKING_HOURS.WORKING_HOURS.SUCCESS:
      {
        var _roomsObj = {};
        if (payload.rooms && payload.rooms.data) {
          _roomsObj = payload.rooms.data;
        }
        return _extends({}, state, _roomsObj, {
          saveWorkingHoursResponse: payload.rooms,
          saveWorkingHoursLoadState: _enum.status.SUCCESS
        });
      }
    case _workingHours.WORKING_HOURS.WORKING_HOURS.FAIL:
      {
        return _extends({}, state, {
          saveWorkingHoursLoadState: _enum.status.FAIL,
          saveWorkingHoursResponse: payload.err
        });
      }

    case _workingHours.WORKING_HOURS.SET_BRANCH_WORKING_HOURS.SUBMIT:
      return _extends({}, state, {
        setBranchWorkingHoursResponse: undefined,
        setBranchWorkingHoursLoadState: _enum.status.SUBMITING
      });
    case _workingHours.WORKING_HOURS.SET_BRANCH_WORKING_HOURS.SUCCESS:
      return _extends({}, state, {
        setBranchWorkingHoursResponse: payload.payload,
        setBranchWorkingHoursLoadState: _enum.status.SUCCESS
      });
    case _workingHours.WORKING_HOURS.SET_BRANCH_WORKING_HOURS.FAIL:
      return _extends({}, state, {
        setBranchWorkingHoursResponse: payload.payload,
        setBranchWorkingHoursLoadState: _enum.status.FAIL
      });

    case _workingHours.WORKING_HOURS.GET_BRANCH_WORKING_HOURS.FETCH:
      return _extends({}, state, {
        branchWorkingHours: undefined,
        getBranchWorkingHoursLoadState: _enum.status.FETCHING
      });
    case _workingHours.WORKING_HOURS.GET_BRANCH_WORKING_HOURS.SUCCESS:
      return _extends({}, state, {
        branchWorkingHours: payload.payload,
        getBranchWorkingHoursLoadState: _enum.status.SUCCESS
      });
    case _workingHours.WORKING_HOURS.GET_BRANCH_WORKING_HOURS.FAIL:
      return _extends({}, state, {
        getBranchWorkingHoursLoadState: _enum.status.FAIL
      });

    default:
      return state;
  }
};

module.exports = exports['default'];